import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'portal',
        name: 'portal',
        component: () => import('@/views/Portal'),
      },
      {
        path: 'registration',
        name: 'registration',
        component: () => import('@/views/Registration'),
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: () => import('@/views/Maintenance'),
      },
    ]
  },
  {path: '*', redirect: '/' }

  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     // meta: { title: 'Dashboard', icon: 'dashboard' }
  //   }]
  // },
]

const router = new VueRouter({
  routes
})

export default router
